export const NAME = 'dashboards-campaigns';

export const campaignViews = {
	CURRENT_CAMPAIGNS: 'currentCampaigns',
	PLANED_CAMPAIGNS: 'planedCampaigns',
};

export const formDataFieldsMap = {
	campaignName: 'Název',
	channel: 'Kanál',
};
